import { gql } from '@apollo/client';
import observationReportDocumentFragment from './observationReportDocumentFragment';

const GET_OBSERVATION_REPORT_DOCUMENT_BY_ID = gql`
  query GetObservationReportDocumentById($observationReportId: Int!) {
    observationReportById(observationReportId: $observationReportId) {
      ...ObservationReportFields
    }
  }
  ${observationReportDocumentFragment}
`;

export default GET_OBSERVATION_REPORT_DOCUMENT_BY_ID;
